import api from './api.service';

export interface InfrastructureMetric {
  id: string;
  resource_id: string;
  timestamp: number;
  cpu_usage_percent?: number;
  cpu_user_percent?: number;
  cpu_system_percent?: number;
  memory_usage_percent?: number;
  memory_used_bytes?: number;
  memory_total_bytes?: number;
  disk_usage_percent?: number;
  disk_used_bytes?: number;
  disk_total_bytes?: number;
  disk_read_bytes?: number;
  disk_write_bytes?: number;
  network_rx_bytes?: number;
  network_tx_bytes?: number;
  load_avg_1m?: number;
  load_avg_5m?: number;
  load_avg_15m?: number;
}

export interface TimeSeriesData {
  timestamp: number;
  time: string;
  value: number;
}

const infrastructureMetricApi = {
  // Get all metrics for a host
  getAll: async (resourceId: string, params?: {
    startTime?: number;
    endTime?: number;
    limit?: number;
    offset?: number;
  }) => {
    const response = await api.get(`/v1/infrastructure/metrics`, {
      params: {
        resourceId,
        ...params,
      },
    });
    return response;
  },

  // Get time series for a specific metric
  getTimeSeries: async (
    resourceId: string,
    metricName: string,
    startTime: number,
    endTime: number
  ) => {
    const response = await api.get(`/v1/infrastructure/metrics/time-series`, {
      params: {
        resourceId,
        metricName,
        startTime,
        endTime,
      },
    });
    return response;
  },

  // Get current/latest metrics for a host
  getCurrent: async (resourceId: string) => {
    const response = await api.get(`/v1/infrastructure/metrics/current/${resourceId}`);
    return response;
  },

  // Get aggregated metrics
  getAggregation: async (
    resourceId: string,
    metricName: string,
    startTime: number,
    endTime: number,
    aggregation: 'avg' | 'sum' | 'min' | 'max' = 'avg'
  ) => {
    const response = await api.get(`/v1/infrastructure/metrics/aggregation`, {
      params: {
        resourceId,
        metricName,
        startTime,
        endTime,
        aggregation,
      },
    });
    return response;
  },
};

export default infrastructureMetricApi;
